import React, { useEffect, useState } from "react"
import { HMSNotificationTypes, useHMSNotifications } from "@100mslive/react-sdk"
import Loader from "components/loader"
import Modal from "components/modal"
import Flex from "../shared/flex"
import { Text } from "../shared/text"
import { Box } from "../shared/box"
import { useToast } from "../hooks/useToast"

const notificationTypes = [
  HMSNotificationTypes.RECONNECTED,
  HMSNotificationTypes.RECONNECTING,
  HMSNotificationTypes.ERROR,
]
let notificationId = null

const isQA = process.env.GATSBY_WEBINAR_REACT_APP_ENV === "qa"
export const ReconnectNotifications = () => {
  const notification = useHMSNotifications(notificationTypes)
  const [open, setOpen] = useState(false)
  const toast = useToast()

  useEffect(() => {
    if (notification?.type === HMSNotificationTypes.ERROR && notification?.data?.isTerminal) {
      setOpen(false)
    } else if (notification?.type === HMSNotificationTypes.RECONNECTED) {
      notificationId = toast.info("Reconnected")
      setOpen(false)
    } else if (notification?.type === HMSNotificationTypes.RECONNECTING) {
      if (isQA) {
        toast.removeToast(notificationId)
        setOpen(true)
      } else {
        toast.info(notification.data.message)
      }
    }
  }, [notification, toast])

  if (!open || !isQA) return null
  
  return (
    open && (
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          css={{
            width: "fit-content",
            maxWidth: "80%",
            padding: "1rem 1.6rem",
            position: "relative",
            top: "unset",
            bottom: "$9",
            transform: "translate(-50%, -100%)",
            animation: "none !important",
          }}
        >
          <Flex align="center">
            <Loader width="50" height="50" />
            <Text>You lost your network connection. Trying to reconnect.</Text>
          </Flex>
        </Box>
      </Modal>
    )
  )
}
